<template>
  <div class="d-flex flex-column overflow-hidden h-100">
    <vue-custom-scrollbar
      class="app-content-padding flex-grow-1 overflow-hidden h-100"
    >
      <ts-page-title
        :title="$t('certificateOperationPrint.pageTitle')"
        :breadcrumb="[
          { text: $t('home'), href: '/' },
          {
            text: $t('certificateOperationPrint.pageTitle'),
            href: '/admin/academic/certificate-operation-prints',
          },
          {
            text: $t('certificateOperationPrint.approve'),
            active: true,
          },
        ]"
      />
      <ts-loading-banner :loading="waiting">
        <ts-panel>
          <ts-panel-wrapper class="tw-space-y-2">
            <h1 class="section-divider-underline">
              {{ $t("certificateOperationPrint.candidate") }}
            </h1>
            <div class="col-12" v-if="approveDatas['candidates']">
              <label class="form-label col-form-label col-md-4">
                <span>Card Number : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].card_number }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Candidate : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].full_name_en }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Sex : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].sex }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Dob : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].dob }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Register Date : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].register_date }}</span
                >
              </label>
              <label class="form-label col-form-label col-md-4">
                <span>Phone : </span>
                <span
                  class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                  >{{ approveDatas["candidates"].phone }}</span
                >
              </label>
            </div>

            <h1 class="section-divider-underline tw-border-t-2 tw-pt-2">
              {{ $t("certificateOperationPrint.levelSkill") }}
            </h1>
            <div class="col-12 tw-space-y-4">
              <div class="col-12">
                <label class="form-label col-form-label col-md-4">
                  <span>Course Name : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"]
                        ? approveDatas["requestSkillLevel"].examination_event
                        : null
                    }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Skill Level : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"]
                        ? approveDatas["requestSkillLevel"].level_skill_name
                        : null
                    }}</span
                  >
                  <span> | Level : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"]
                        ? approveDatas["requestSkillLevel"].skill_level_order
                        : null
                    }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Certficate Type : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"]
                        ? approveDatas["requestSkillLevel"].cert_type_name
                        : null
                    }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Available Year : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"]
                        ? approveDatas["requestSkillLevel"].available_in_year
                        : null
                    }}</span
                  >
                </label>
                <label class="form-label col-form-label col-md-4">
                  <span>Expire Date : </span>
                  <span
                    class="tw-text-blue-600 tw-font-extrabold tw-tracking-wider"
                    >{{
                      approveDatas["requestSkillLevel"]
                        ? approveDatas["requestSkillLevel"].expire_date
                        : null
                    }}</span
                  >
                </label>
              </div>
              <div class="row tw-h-auto">
                <table class="tw-w-full">
                  <thead>
                    <tr class="tw-uppercase tw-bg-gray-200 tw-h-10">
                      <th class="tw-pl-2" style="width: 30%">
                        {{ $t("certificateOperationPrint.subject") }}
                      </th>
                      <th class="tw-text-center" style="width: 20%">
                        {{ $t("certificateOperationPrint.isPass") }}
                      </th>
                      <th style="width: 70%">
                        {{ $t("certificateOperationPrint.remark") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(subject, index) in approveDatas[
                        'requestSkillLevel'
                      ].evaluation_examinations"
                      :key="index"
                      class="tw-w-full tw-h-10"
                    >
                      <td class="tw-whitespace-no-wrap tw-pl-2">
                        {{ subject.subject_name_en }}
                      </td>
                      <td class="tw-text-center tw-items-center">
                        <span
                          class="tw-text-green-500"
                          v-if="subject.is_passed"
                        >
                          <a-icon type="check-circle" class="tw-text-lg" />
                        </span>
                        <span v-else class="tw-text-red-500">
                          <a-icon type="close-circle" class="tw-text-lg" />
                        </span>
                      </td>
                      <td class="tw-whitespace-no-wrap">
                        <input
                          disabled
                          v-model="subject.remarks"
                          placeholder="remarks"
                          style="min-width: 90px"
                          class="form-control"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ts-panel-wrapper>
        </ts-panel>
      </ts-loading-banner>
    </vue-custom-scrollbar>
    <div
      id="footer"
      class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2 tw-sh"
      style="background-color: #e9ecef"
    >
      <ts-button
        @click.prevent="$router.push({ name: 'certificate-operation-print' })"
        :disabled="waiting_new || waiting"
        class="btn-gray"
      >
        {{ $t("cancel") }}</ts-button
      >
      <ts-button
        color="danger"
        outline
        :waiting="waiting_new"
        :disabled="waiting_new || waiting"
        @click.prevent="onReject"
      >
        {{ $t("certificateOperationPrint.reject") }}</ts-button
      >
      <ts-button
        color="primary"
        :waiting="waiting"
        :disabled="waiting_new || waiting"
        @click.prevent="onApprove"
      >
        {{ $t("certificateOperationPrint.approve") }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import { mapActions, mapState } from "vuex";
import { Errors } from "form-backend-validation";

export default {
  name: "certificateOperationPrintCreate",
  components: {},
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      printing_id: null,
      errors: new Errors(),
    };
  },
  created() {
    AppOptions.appContentFullHeight = true;
    AppOptions.appContentClass = "p-0";
  },
  computed: {
    ...mapState("academic/certificateOperationPrint", [
      "edit_data",
      "approveDatas",
    ]),
  },
  methods: {
    ...mapActions("academic/certificateOperationPrint", ["approve"]),
    async fetchFormViewModel({
      candidate_id,
      exam_register_id,
      certificate_id,
    }) {
      this.waiting = true;
      await this.approve({
        index: undefined,
        params: {
          candidate_id: candidate_id,
          exam_register_id: exam_register_id,
          certificate_id: certificate_id,
        },
      });
      this.waiting = false;
    },
    async onApprove() {
      this.waiting = true;
      this.$store
        .dispatch(
          "academic/certificateOperationPrint/certificateOperationPrintApprove",
          {
            id: this.printing_id,
            data: { is_approved: true },
          }
        )
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .finally(() => {
          this.waiting = false;
          this.$router.push({ name: "certificate-operation-print" });
        });
    },
    async onReject() {
      this.waiting = true;
      this.$store
        .dispatch(
          "academic/certificateOperationPrint/certificateOperationPrintApprove",
          {
            id: this.printing_id,
            data: { is_approved: false },
          }
        )
        .then(async (response) => {
          this.$notify({ type: "success", text: response.message });
          this.$emit("cancel");
        })
        .finally(() => {
          this.waiting = false;
          this.$router.push({ name: "certificate-operation-print" });
        });
    },
    clearError() {
      this.errors = new Errors();
    },
    clearInput() {
      (this.model.course_skill_id = null), (this.model.is_evaluated = false);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.printing_id = to.params.printing_id;
      vm.fetchFormViewModel({
        candidate_id: to.params.candidate_id,
        exam_register_id: to.params.exam_register_id,
        certificate_id: to.params.certificate_id,
      });
    });
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appContentFullHeight = false;
    AppOptions.appContentClass = "";
    next();
  },
};
</script>
